

import React from "react";
import Nav from "../HomePage/Nav";
import help from "../../assets/Images/vatsal-bhatt-KwhxKAjhIjQ-unsplash1.png";
import "react-toastify/dist/ReactToastify.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebook,
  faInstagram,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import p1 from "../../assets/Images/P1.png";
import p2 from "../../assets/Images/P2.png";
import lad from "../../assets/Images/11.png";
import snow from "../../assets/Images/12.png";
import Seo from "../Seo/Seo";
import { useSeoMeta } from "../Seo/useSeoMeta";
import { SITE_NAME } from "../Seo/seoConfig";

const ContactUs = () => {
  const centralizedSeo = useSeoMeta();
  return (
<>
  <Seo
    title={`Contact Us | ${SITE_NAME}`}
    description={`Get in touch with ${SITE_NAME} for Ladakh tour bookings, enquiries and travel planning support.`}
    type="website"
    centralizedSeo={centralizedSeo}
  />
  <style>
    {`
      /* Mobile devices (up to 768px) */
      @media (max-width: 767.98px) {
        .contact-info-section {
          height: auto !important;
          min-height: auto !important;
          padding-top: 2rem !important;
          padding-bottom: 2rem !important;
        }
        
        .contact-info-section .d-flex {
          align-items: flex-start !important;
        }
      }
      
      /* Desktop and larger screens */
      @media (min-width: 768px) {
        .contact-info-section {
          height: 368px;
          min-height: 300px;
        }
      }
    `}
  </style>

  {/* ✅ Background + Overlay Wrapper */}
  <div
    style={{
      backgroundImage: `url(${help})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      minHeight: "100vh",
      width: "100%",
      position: "relative",
    }}
  >
    {/* ✅ Black overlay */}
    <div
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.6)",
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1,
      }}
    />

    {/* ✅ Page Content */}
    <div style={{ position: "relative", zIndex: 2 }}>
      <Nav />

      {/* Contact Info Section */}
      <div className="container text-white d-flex align-items-end justify-content-between contact-info-section">
        <div className="row text-center w-100 g-3">
          <div className="col-12 col-md-4 p-3 p-md-5">
            <h1
              className="h2 h1-md"
              style={{
                fontFamily: "Montserrat",
                fontWeight: 600,
                fontSize: "clamp(32px, 8vw, 52px)",
                lineHeight: "100%",
                letterSpacing: "0%",
                verticalAlign: "middle",
              }}
            >
              <b>Contact Us</b>
            </h1>
            <p className="mb-0">Get in touch with us for any enquiries and questions</p>
          </div>

          <div className="col-12 col-md-4 mt-3 mt-md-5">
            <p><b>Mobile</b></p>
            <a href="tel:+917006363828" className="text-white d-block text-decoration-none">+91 7006363828</a>
            <a href="tel:+919149516495" className="text-white d-block mt-2 text-decoration-none">+91 9149516495</a>
            <p className="mt-4"><b>Address</b></p>
            <p className="mb-0">Chhutay Rantak, Sankar Road</p>
            <p>Opp. Hotel Antelope, Leh-Ladakh, 194101</p>
          </div>

          <div className="col-12 col-md-4 mt-3 mt-md-5 d-md-flex flex-md-column justify-content-lg-around">
          <div className="mail-box mb-3 mb-md-0">
            <p><b>Mail</b></p>
            <a href="mailto:travellerschoice27@gmail.com" className="text-white text-decoration-none mb-3 d-block">travellerschoice27@gmail.com</a>
            </div>
            <div className="social-box"> 
            <p className="mt-4 mt-md-4"><b>Social Media</b></p>
            <div className="d-flex justify-content-center gap-2">
              <a href="https://www.facebook.com/profile.php?id=100088895292951&mibextid=ZbWKwL" target="_blank" rel="noreferrer" className="bg-white p-2 rounded-circle d-flex align-items-center justify-content-center" style={{ width: "40px", height: "40px" }}>
                <FontAwesomeIcon icon={faFacebook} className="text-primary" />
              </a>
              <a href="https://www.instagram.com/travellers_choice_ladakh/" target="_blank" rel="noreferrer" className="bg-white p-2 rounded-circle d-flex align-items-center justify-content-center" style={{ width: "40px", height: "40px" }}>
                <FontAwesomeIcon icon={faInstagram} className="text-primary" />
              </a>
              <a href="https://youtube.com/@TRAVELLERSCHOICE-ll2kl?si=EX6n-jYw7HA-1oK3" target="_blank" rel="noreferrer" className="bg-white p-2 rounded-circle d-flex align-items-center justify-content-center" style={{ width: "40px", height: "40px" }}>
                <FontAwesomeIcon icon={faYoutube} className="text-primary" />
              </a>
            </div>
             </div>
          </div>
        </div>
      </div>

      {/* ✅ Responsive Image Grid */}
      <div className="w-100 py-4">
        <div className="container">
          <div className="row g-3">
            {/* Desktop and Tablet Layout */}
            <div className="d-none d-md-block">
              {/* Row 1 */}
              <div className="col-12 d-flex flex-wrap gap-3 justify-content-between mb-3">
                <img
                  src={p1}
                  alt="Tourists enjoying a scenic view in Ladakh"
                  className="rounded"
                  style={{ width: "32%", height: "200px", objectFit: "cover" }}
                />
                <img
                  src={p2}
                  alt="Beautiful travel destination in Ladakh with panoramic mountain views"
                  className="rounded"
                  style={{ width: "64%", height: "200px", objectFit: "cover" }}
                />
              </div>

              {/* Row 2 */}
              <div className="col-12 d-flex flex-wrap gap-3 justify-content-between">
                <img
                  src={lad}
                  alt="Beautiful valley surrounded by mountains in Ladakh"
                  className="rounded"
                  style={{ width: "32%", height: "200px", objectFit: "cover" }}
                />
                <img
                  src={snow}
                  alt="Snow-covered mountains in Leh Ladakh during winter"
                  className="rounded"
                  style={{ width: "32%", height: "200px", objectFit: "cover" }}
                />
                <img
                  src={p2}
                   alt="Breathtaking mountain scenery in Ladakh for adventure travelers"
                  className="rounded"
                  style={{ width: "32%", height: "200px", objectFit: "cover" }}
                />
              </div>
            </div>

            {/* Mobile Layout - Stacked Images */}
            <div className="d-md-none">
              <div className="row g-3">
                <div className="col-12">
                  <img
                    src={p1}
                    alt="Scenic mountain landscape in Ladakh by Travellers Choice Ladakh"
                    className="img-fluid rounded w-100"
                    style={{ height: "200px", objectFit: "cover" }}
                  />
                </div>
                <div className="col-12">
                  <img
                    src={p2}
                    alt="Beautiful travel destination in Ladakh."
                    className="img-fluid rounded w-100"
                    style={{ height: "200px", objectFit: "cover" }}
                  />
                </div>
                <div className="col-12">
                  <img
                    src={lad}
                    alt="Beautiful valley in Ladakh"
                    className="img-fluid rounded w-100"
                    style={{ height: "200px", objectFit: "cover" }}
                  />
                </div>
                <div className="col-12">
                  <img
                    src={snow}
                    alt="Snow-covered mountains in Leh Ladakh during winter"
                    className="img-fluid rounded w-100"
                    style={{ height: "200px", objectFit: "cover" }}
                  />
                </div>
                <div className="col-12">
                  <img
                    src={p2}
                     alt="Breathtaking mountain scenery in Ladakh for adventure travelers"
                    className="img-fluid rounded w-100"
                    style={{ height: "200px", objectFit: "cover" }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</>

  );
};

export default React.memo(ContactUs);



